<script lang="ts">
	import { getContext } from 'svelte';
	import Accordion from '$lib/components/Accordion.svelte';
	import List from '$lib/elements/List.svelte';
	import { viewport } from '$lib/stores/viewport';
	import { isSidebarOpen } from '@app/stores/sidebar';

	let sublistsClass = getContext('sublistsClass') as string;
	let sublistsLabelClass = getContext('sublistsLabelClass') as string;

	export let label;
	export let subItems;
	export let isOpen;
</script>

{#if $viewport.isTablet || $viewport.isMobile}
	<Accordion {isOpen}>
		<div slot="header" class={sublistsLabelClass}>{label}</div>
		<List
			classNames={sublistsClass}
			items={subItems}
			slot="content"
			itemOnClick={() => ($isSidebarOpen = false)}
		/>
	</Accordion>
{:else}
	<div class={sublistsLabelClass}>
		{label}
	</div>
	<List items={subItems} classNames={sublistsClass} />
{/if}
